import { IRepeaterItem } from 'src/components/repeater/Repeater';
import { Item } from './itemList';

export interface VendorBooth {
  id: number;
  name: string;
  showId: string;
  boothVendors: BoothVendor[];
  boothProperties: BoothProperty[];
  productHighlights: ProductHighlight[];
  boothContacts: BoothContact[];

  /**
   * Starting items for the product highlights form, when the user clicks the dropdown and no search term is entered they will see these items
   */
  startingItems: Item[];
  isLoading: boolean;
}

export interface BoothVendor {
  //Vendor number
  key: string;
  label: string;
}

export interface BoothProperty {
  id: number;
  alias: string;
  value?: string | number;
}

export interface ProductHighlight extends IRepeaterItem {
  key?: string;
  name: string;
  itemNumber: string;
  title: string;
  subtitle?: string;
  description?: string;
  imageOverride?: string;

  //React specific fields
  inEdit?: boolean;
}

export const initialProductHighlight: ProductHighlight = {
  key: '',
  name: '',
  itemNumber: '',
  title: '',
  subtitle: '',
  description: '',
  imageOverride: '',
};

export interface BoothContact extends IRepeaterItem {
  key?: string;
  name?: string;
  ncContentTypeAlias?: string;
  fullName: string;
  phoneNumber: string;
  emailAddress: string;

  //React specific fields
  inEdit?: boolean;
}

export const initialVendorBooth: VendorBooth = {
  id: 0,
  name: '',
  showId: '',
  isLoading: false,
  boothVendors: [],
  boothProperties: [],
  productHighlights: [],
  boothContacts: [],
  startingItems: [],
};
